import { default as GrsIcon } from "./grs"
import { default as GrpIcon } from "./grp"
import { default as ShrpIcon } from "./shrp"
import { ReactComponent as TapIcon } from "./tap.svg"
import { ReactComponent as PipeIcon } from "./pipe.svg"

function IconDisplay(props: React.PropsWithChildren<React.SVGProps<SVGSVGElement>> & {iconType: string, sensorData?: any}): JSX.Element  {
    const { iconType, sensorData, ...rest } = props

    switch(iconType) {
        case "gas_gts_grs":
            return <GrsIcon data={sensorData} {...rest} />
        case "gas_gts_grp":
            return <GrpIcon data={sensorData} {...rest}/>
        case "gas_gts_shrp":
            return <ShrpIcon data={sensorData} {...rest}/>
        case "gas_gts_tap":
            return <TapIcon {...rest}/>
    }

    if (iconType.startsWith("gas_gts") && iconType.endsWith("_port")) {
        return <PipeIcon {...rest}/>
    }

    return (
        <></>
    )
}

export { IconDisplay }
